/**
 * Created by razial on 10.04.2024.
 */

var ConnectorActionPlayer = function (options) {
    options = options || {};
    this.options = options;

    if (Array.isArray(options)) {
        options = { actions: options };
    } else if (typeof options === "function") {
        options = { actions: [options] };
    }

    this.actions = [];
    this.add(options.actions || []);
};

ConnectorActionPlayer.prototype.add = function (actions) {
    if (Array.isArray(actions)) {
        actions.forEach(function (action) {
            this.add(action);
        }.bind(this));
    } else if (actions) {
        this.actions.push(actions);
    }
};

ConnectorActionPlayer.prototype._playNext = function () {
    if (this.actionTimeout) {
        clearTimeout(this.actionTimeout);
        this.actionTimeout = undefined;
    }

    if (this._stopped) {
        return;
    }

    if (this.index === this.actions.length) {
        this._stopped = true;

        if (this.onCompleteListener) {
            this.onCompleteListener.call(null);
        }

        if (this.onSuccessListener) {
            this.onSuccessListener.call(null);
        }

        return;
    }

    var active = true;

    var resolve = function () {
        if (active) {
            active = false;
            this._playNext.apply(this, arguments);
        }
    }.bind(this);

    var reject = function () {
        if (active) {
            active = false;
            this.stop.apply(this, arguments);
        }
    }.bind(this);

    if (this.options.actionTimeout) {
        this.actionTimeout = setTimeout(reject, this.options.actionTimeout);
    }

    this.actions[this.index++](resolve, reject);
};

ConnectorActionPlayer.prototype.onSuccess = function (callback) {
    this.onSuccessListener = callback;
};

ConnectorActionPlayer.prototype.onFailure = function (callback) {
    this.onFailureListener = callback;
};

ConnectorActionPlayer.prototype.onComplete = function (callback) {
    this.onCompleteListener = callback;
};

ConnectorActionPlayer.prototype.play = function (callback) {
    this.index = 0;
    if (callback) {
        this.onSuccess(callback);
    }
    this._playNext();
};

ConnectorActionPlayer.prototype.stop = function () {
    if (!this._stopped) {
        this._stopped = true;

        if (this.onCompleteListener) {
            this.onCompleteListener.call(null);
        }

        if (this.onFailureListener) {
            this.onFailureListener.apply(null, arguments);
        }
    }
};

ConnectorActionPlayer.prototype.isStopped = function () {
    return this._stopped;
};

ConnectorActionPlayer.prototype.isRunning = function () {
    return !this.isStopped();
};
